const DefaultState = {
  openState: false,
}

export { DefaultState }
